import { useCallback, useRef } from 'react';
import { Flex, RootScreen, Spinner } from '@banhala/ui-kit';
import { useReportTTFD } from '../../hooks';
import {
  ScreensResult,
  ScreensAnalyticsProvider,
  ScreensPrefetcher,
} from '../../components';
import { FilterListAtomicProvider } from 'shared/src/component';
import {
  useHasBeenFocusedTab,
  useInstanceId,
  useIsFocusedTab,
  useNativeScrollSync,
  useNativeScrollToTop,
} from 'shared/src/hooks';
import type { AtomicRendererRefCurrent } from '../../components/types';
import { useRootRoute } from 'shared/src/hooks/useRootNavigation';

export const FragmentScreens = () => {
  useReportTTFD();
  const route = useRootRoute<'FragmentScreens'>();

  const instanceId = useInstanceId();
  const { hasBeenFocused, setHasBeenFocused } = useHasBeenFocusedTab();
  const isFocused = useIsFocusedTab();

  const listRef = useRef<AtomicRendererRefCurrent>(null);

  const {
    onScroll: onScrollSync,
    onScrollBeginDrag: onScrollBeginDragSync,
    onScrollEndDrag: onScrollEndDragSync,
  } = useNativeScrollSync({ instanceId });

  const scrollToTop = useCallback(() => {
    listRef.current?.scrollToOffset({ offset: 0, animated: true });
  }, []);

  useNativeScrollToTop({
    onScrollToTop: scrollToTop,
    screen: route.params.screen_name ?? '',
  });

  return (
    <ScreensAnalyticsProvider>
      <RootScreen>
        <Flex
          flex={1}
          onPress={() => {}}
          onPressIn={() => setHasBeenFocused(true)}
        >
          <FilterListAtomicProvider>
            <ScreensPrefetcher />
            {hasBeenFocused ? (
              <ScreensResult
                isForeground={isFocused}
                listRef={listRef}
                onScrollY={onScrollSync}
                onBeginDrag={onScrollBeginDragSync}
                onEndDrag={onScrollEndDragSync}
                hideScreenToTop={true}
                viewLogEnabled={isFocused}
              />
            ) : (
              <Flex.Center flex={1}>
                <Spinner />
              </Flex.Center>
            )}
          </FilterListAtomicProvider>
        </Flex>
      </RootScreen>
    </ScreensAnalyticsProvider>
  );
};
